import type { Doc } from "building-types/doc";
import type { PlanSetTemplateHandle } from "building-types/handles/docEntityHandleTypes";
import type {
  BuiltInPlanSetTemplateIdentifier,
  CustomPlanSetTemplateIdentifier,
  PlanSetTemplateIdentifier,
} from "./planSets";

export function isBuiltInPlanSetTemplateIdentifier(
  identifier: PlanSetTemplateIdentifier,
): identifier is BuiltInPlanSetTemplateIdentifier {
  return identifier.type === "BUILT_IN";
}

export function isCustomPlanSetTemplateIdentifier(
  identifier: PlanSetTemplateIdentifier,
): identifier is CustomPlanSetTemplateIdentifier {
  return identifier.type === "CUSTOM" && identifier.templateId !== "";
}

export function docPlanSetTemplateIdentifierToPlanSetHandle(
  doc: Doc,
  identifier: PlanSetTemplateIdentifier,
): PlanSetTemplateHandle | undefined {
  if (isBuiltInPlanSetTemplateIdentifier(identifier)) {
    return undefined;
  }

  const planSetTemplate = doc.planSetTemplates[identifier.templateId];

  if (!planSetTemplate) {
    console.error("Plan set template not found for identifier ", JSON.stringify(identifier, null, 2));
    return undefined;
  }

  return {
    type: "PLAN_SET_TEMPLATE",
    id: planSetTemplate.id,
  };
}
